// @ts-strict-ignore
import { Address } from 'api/orgs';
import { FilestackImageData, SlideshowData } from 'api/types/shared.types';
import { getJson } from 'utils/http';

export type Testimonial = {
  image: FilestackImageData;
  text: string;
  name: string;
  year: string | number;
  degree: string;
  id: string | null | undefined;
};
export type GradFairId =
  | 'NYC'
  | 'BOS'
  | 'PHL'
  | 'WDC'
  | 'MSP'
  | 'CHI'
  | 'LAX'
  | 'SFO'
  | 'SEA'
  | 'ATL';
export type GradProgram = {
  type: 'GRAD_PROGRAM';
  id: string;
  name: string;
  schoolName: string;
  description: string;
  descriptionTruncated: string | null | undefined;
  whatsSpecial: string;
  phone: string;
  email: string;
  address: Address;
  url: Record<string, string>;
  links: Array<string>;
  created: string;
  updated: string;
  org: {
    id: string;
    name: string;
    url: Record<string, string>;
    orgType: string;
  };
  logo: FilestackImageData | null | undefined;
  banner: FilestackImageData | null | undefined;
  slideshowItems: Array<SlideshowData>;
  applicationGRE: boolean;
  applicationGMAT: boolean;
  applicationTOEFL: boolean;
  applicationIELTS: boolean;
  applicationPTE: boolean;
  applicationLettersRecomm2: boolean;
  applicationLettersRecomm3: boolean;
  applicationAcademicTranscripts: boolean;
  applicationPersonalStatement: boolean;
  additionalRequirements: string;
  nbOfStudents: number | null | undefined;
  maleStudents: number | null | undefined;
  femaleStudents: number | null | undefined;
  isHistoricallyBlack: boolean;
  hasDiversityOffice: boolean;
  isMinorityServing: boolean;
  careers: string | null | undefined;
  associations: string | null | undefined;
  applicationFee: number | null | undefined;
  avgInStateTuition: number | null | undefined;
  avgOutStateTuition: number | null | undefined;
  workStudyAvailable: boolean;
  financialAidIntl: boolean;
  applicationFeeWaiver: boolean;
  avgFinancialAid: number;
  applicationDeadline: string | null | undefined;
  testimonials: Array<Testimonial>;
  acceptanceRate: number;
  tuitionCustomItems: Array<string>;
  studentBodyCustomItems: Array<string>;
  admissionCustomItems: Array<string>;
  isHidden: boolean;
  areasOfStudy: Array<string>;
  degreeProgramsOffered: Array<string>;
  fairLocations: Array<GradFairId>;
};
export function fetchGradProgram(programId: string): Promise<GradProgram> {
  return getJson(`/data/website/grad-programs/${programId}`).then(
    ({ data, gradProgram }) => data || gradProgram
  );
}
